import React from 'react';
import { useSelector } from 'react-redux';

import './DeliveryMethodEstimation.scss';

import {
  getDirectDepositTimelines,
  getExpressDeliveryTimelines,
  getMailACheckTimelines,
} from '../../../redux/modules/sellTransaction/sellTransaction.selectors';
import Case from '../../Shared/Switch/Case';
import If from '../../Shared/If/If';
import Switch from '../../Shared/Switch/Switch';
import { isAutomaticSell, isAppSell } from 'src/utils/transactions-util';
import {
  DELIVERY_DIRECT_DEPOSIT,
  DELIVERY_EXPRESS_DELIVERY,
  DELIVERY_MAIL_CHECK,
  DELIVERY_IN_KIND,
  EXPRESS_DELIVERY_CORE_FEE,
  EXPRESS_DELIVERY_MIN_TRANSACTION,
  DELIVERY_MAIL_CHECK_TO_SCHOOL,
  DELIVERY_MAIL_CHECK_TO_CHARITY,
  DELIVERY_MAIL_CHECK_QCD,
  isYearAfter2024,
} from '../../../settings/settings';
import { formatUTCDate } from '../../../utils/dates/date-utility';
import {
  currency,
  currencyNoPrecision,
  getClientType,
} from '../../../utils/utils';
import { isQCD } from '../../../utils/transactions-util';

const DeliveryMethodEstimation = (props) => {
  const { minimum: depositMin, maximum: depositMax } = useSelector(
    getDirectDepositTimelines
  );
  const { minimum: expressMin, maximum: expressMax } = useSelector(
    getExpressDeliveryTimelines
  );
  const { minimum: checkMin, maximum: checkMax } = useSelector(
    getMailACheckTimelines
  );
  const {
    className,
    deliveryMethod,
    numberOfBanks,
    personalData,
    unavailableText,
  } = props;
  const client = getClientType(personalData.entitySegment);

  return (
    <div className={className}>
      <Switch test={deliveryMethod}>
        <Case value={DELIVERY_DIRECT_DEPOSIT}>
          <If test={numberOfBanks === 0}>
            <div className="hidden-xs hidden-sm">No bank on file.</div>
          </If>
          <If test={numberOfBanks > 0}>
            {isAutomaticSell() || isAppSell() ? (
              <div className="delivery-method-estimation-date">
                Estimated delivery 2-3 days from trade date
              </div>
            ) : (
              <div className="delivery-method-estimation-date">
                Est. delivery {formatUTCDate(depositMin)} to{' '}
                {formatUTCDate(depositMax)}
              </div>
            )}
            {!isAutomaticSell() && !isQCD() && <div>Complimentary</div>}
          </If>
        </Case>
        <Case value={DELIVERY_MAIL_CHECK}>
          <If test={!unavailableText}>
            {isAutomaticSell() || isAppSell() ? (
              <div className="delivery-method-estimation-date">
                Estimated delivery 7-10 days from trade date
              </div>
            ) : (
              <div className="delivery-method-estimation-date">
                Est. delivery {formatUTCDate(checkMin)} to{' '}
                {formatUTCDate(checkMax)}
              </div>
            )}
            {!isAutomaticSell() && !isQCD() && <div>Complimentary</div>}
          </If>
          <If test={unavailableText}>
            <div className="hidden-xs hidden-sm"> Unavailable</div>
          </If>
        </Case>
        <Case value={DELIVERY_MAIL_CHECK_QCD}>
          <div className="delivery-method-check-max">
            Max. ${isYearAfter2024() ? '108,000' : '105,000'}
          </div>
          <div className="delivery-method-estimation-date">
            Est. delivery {formatUTCDate(checkMin)} to {formatUTCDate(checkMax)}
          </div>
          {!isQCD() && <div>Complimentary</div>}
        </Case>
        <Case value={DELIVERY_EXPRESS_DELIVERY}>
          <If test={numberOfBanks === 0}>
            <div className="hidden-xs hidden-sm">No bank on file.</div>
          </If>
          <If test={numberOfBanks > 0}>
            {isAppSell() ? (
              <div className="delivery-method-estimation-date">
                Estimated delivery 1-2 days from trade date
              </div>
            ) : (
              <div className="delivery-method-estimation-date">
                Est. delivery {formatUTCDate(expressMin)} to{' '}
                {formatUTCDate(expressMax)}
              </div>
            )}
            <div className="hidden-xs hidden-sm">Fees may apply</div>
            <If test={client === 'core' || client === 'preferred'}>
              <div className="hidden-md hidden-lg">
                Complimentary for transactions over{' '}
                {currencyNoPrecision(EXPRESS_DELIVERY_MIN_TRANSACTION)}.
                Transactions less than{' '}
                {currencyNoPrecision(EXPRESS_DELIVERY_MIN_TRANSACTION)} will
                incur a {currency(EXPRESS_DELIVERY_CORE_FEE)} fee for each fund
              </div>
            </If>
            <If
              test={
                client === 'high_value' ||
                client === 'enhanced_personal' ||
                client === 'personal'
              }
            >
              <div className="hidden-md hidden-lg">
                <span> Complimentary</span>
              </div>
            </If>
          </If>
        </Case>
        <Case value={DELIVERY_IN_KIND}>
          <div className="delivery-method-estimation-empty" />
        </Case>
        <Case value={DELIVERY_MAIL_CHECK_TO_SCHOOL}>
          <div className="delivery-method-estimation-date">
            Est. delivery {formatUTCDate(checkMin)} to {formatUTCDate(checkMax)}
          </div>
          {!isQCD() && <div>Complimentary</div>}
        </Case>
        <Case value={DELIVERY_MAIL_CHECK_TO_CHARITY}>
          <div className="delivery-method-check-max">
            Max. ${isYearAfter2024() ? '108,000' : '105,000'}
          </div>
          <div className="delivery-method-estimation-date">
            Est. delivery {formatUTCDate(checkMin)} to {formatUTCDate(checkMax)}
          </div>
          {!isQCD() && <div>Complimentary</div>}
        </Case>
      </Switch>
    </div>
  );
};

export default DeliveryMethodEstimation;
